module.exports = __webpack_public_path__ + "img/search.5437e521.svg";